import type { ColorScheme } from '@pesto/utils/src/style/colorSchemeHelper';

const MONEY_ON_STREET_SIDEBAR_COLORS = {
  '--sidebar': 'var(--primary)',
  '--sidebar-border': '151 55% 70%',
  '--sidebar-text': '0 0% 78%',
  '--sidebar-text-hover': '151 55% 70%',
  '--sidebar-text-selected': '151 55% 70%',
  '--sidebar-text-selected-foreground': '151 55% 70%',
};

export enum ColorSchemeValue {
  DEFAULT = 'default',
  Blue = 'blue',
  PINK = 'pink',
  GREEN = 'green',
  ORANGE = 'orange',
}

export const colorSchemes: Record<ColorSchemeValue, ColorScheme> = {
  default: {
    '--background': '0 0% 100%',
    '--foreground': '240 10% 3.9%',
    '--card': '0 0% 100%',
    '--card-foreground': '240 10% 3.9%',
    '--popover': '0 0% 100%',
    '--popover-foreground': '240 10% 3.9%',
    '--primary': '240 5.9% 10%',
    '--primary-foreground': '0 0% 98%',
    '--secondary': '240 4.8% 95.9%',
    '--secondary-foreground': '240 5.9% 10%',
    '--muted': '240 4.8% 95.9%',
    '--muted-foreground': '240 3.8% 46.1%',
    '--accent': '240 4.8% 95.9%',
    '--accent-foreground': '240 5.9% 10%',
    '--destructive': '0 84.2% 60.2%',
    '--destructive-foreground': '0 0% 98%',
    '--border': '240 5.9% 90%',
    '--input': '240 5.9% 90%',
    '--ring': '240 5.9% 10%',
    '--chart-1': '197 82% 41%',
    '--chart-2': '313 81% 61%',
    '--chart-3': '197 37% 24%',
    '--chart-4': '43 74% 66%',
    '--chart-5': '27 87% 67%',
    ...MONEY_ON_STREET_SIDEBAR_COLORS,
  },
  blue: {
    '--primary': '200 80% 50%',
    '--accent': '180 70% 60%',
    ...MONEY_ON_STREET_SIDEBAR_COLORS,
  },
  pink: {
    '--primary': '330 80% 50%',
    '--accent': '310 70% 60%',
    ...MONEY_ON_STREET_SIDEBAR_COLORS,
  },
  green: {
    '--primary': '150 80% 15%',
    '--accent': '145 70% 20%',
    '--muted': '142 33% 95%',
    ...MONEY_ON_STREET_SIDEBAR_COLORS,
  },
  orange: {
    '--primary': '30 80% 50%',
    '--accent': '20 70% 60%',
    ...MONEY_ON_STREET_SIDEBAR_COLORS,
  },
};
